import { getLatesUnepCertificateAction } from "../getLatesUnepCertificate.action";
import $api from "../../../../../services/axiosService";

import moment from "moment";

function normalizePhoneDigits(phone) {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    // сравниваем по последним 10 цифрам: БК отдаёт номер с кодом страны (+79182074800),
    // сертификат — без него (9182074800)
    return digits.length > 10 ? digits.slice(-10) : digits;
}

export const getLatesUnepCertificateThunkAction =
    (props) => async (dispatch) => {
        try {
            const response = await $api("v1/c/certificates/latest");
            if (response.status) {
                if (response.data !== {}) {
                    const temp = { ...response.data };
                    if (temp.validDate) {
                        const timeToNote = moment(temp.validDate).add(-21, "d");
                        if (new Date().getTime() > new Date(temp.validDate).getTime()) {
                            temp.valid = "completely expired";
                        } else if (
                            new Date().getTime() >
                            new Date(timeToNote).getTime()
                        ) {
                            temp.valid = "expired";
                        }
                    }
                    const resp = await $api("/v1/c/certificates/issues/latest");

                    temp.certPhone = resp.data?.phone || null;
                    try {
                        const responseNumber = await $api.get("/v1.0/c/u/10");
                        temp.bkPhone = responseNumber.data?.data?.phoneNumber
                            ? `+${responseNumber.data.data.phoneNumber}`
                            : null;
                    } catch (bkError) {
                        temp.bkPhone = null;
                    }
                    temp.phoneMismatch = Boolean(
                        temp.certPhone &&
                        temp.bkPhone &&
                        normalizePhoneDigits(temp.certPhone) !== normalizePhoneDigits(temp.bkPhone),
                    );

                    if (resp.status) {
                        switch (resp.data.status) {
                        case 80:
                            if (temp.valid === "expired") {
                                temp.status = "Срок действия ЭЦП истекает";
                            } else {
                                temp.status = "Готов";
                            }
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 50:
                            temp.status = "Ошибка";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 10:
                            temp.status = "Требует подтверждения через смс";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 20:
                            temp.status =
                                    "Требует подтверждения через ГосУслуги";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 30:
                            temp.status = "Подтверждена";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 40:
                            temp.status = "Ошибка подтверждения";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 60:
                            temp.status = "Проверка документов";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 70:
                            temp.status = "Ошибка валидации";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 75:
                            temp.status = "Выпуск сертификата";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 90:
                            temp.status = "Ошибка выпуска";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 100:
                            temp.status = "Ошибка ";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp}),
                            );
                        case 0:
                            temp.status = "Новая ";
                            return dispatch(
                                getLatesUnepCertificateAction({  ...resp.data, ...temp }),
                            );

                        default:
                            return temp;
                        }
                    }
                }
                dispatch(getLatesUnepCertificateAction(response.data));
            }
        } catch (e) {
            if (props) {
                props.setErrDescription(e?.response?.detail);
                props.setErrorModal(true);
            }
        }
    };
